<template>
	<div style="padding:8px 15px 8px;" id="datiye">
		<div class="content">
			<el-row :gutter="0">
				<el-col :span="12" style="padding-top:66px ">
					<p class="title1" style="font-size: 20px;">{{num}}、{{data11.question}}<span class="title1f" style="font-weight: bold">({{data11.series_name}}）</span></p>
					<div style="margin-bottom:20px ">
						<el-radio-group v-model="radio2" @change="tijiao">
							<p class="selectlist" v-for="(ti,index) in data11.details" :key="index">
								<el-radio :label="ti.id">{{index|shuju}}、{{ti.option}}</el-radio>
							</p>
						</el-radio-group>
					</div>
					<!--<p class="contentTitle">注解</p>-->
					<!--<p class="notePart" v-for="(detail,index) in data11.details" :key="index">{{detail.intro}}</p>-->
					<!--<div class="tijiaoBtn">提交</div>-->
				</el-col>

				<el-col :span="12" style="padding-top:66px ">
					<div>
						<div class="cepingBox">
							<p class="contentTitle">测评指导</p>

							<p class="notePart2"><img class="cepingi" src="/static/qmsj/img/cepingbox1.jpg" alt="">准备道具</p>
							<div class="cepcontBox">
								<img class="cepingimg" :src="data11.prop_img" v-if="data11.prop_img" alt="">
								<p style="padding-left:12px ">{{data11.prop}}</p>
							</div>
							<p style="margin: 0 0 8px 63px;font-size: 14px;">提示：</p>
							<p style="margin: 0 0 8px 63px;font-size: 14px;">1.下一题类型：{{data11.next_series_name}}</p>
							<p style="margin: 0 0 15px 63px;font-size: 14px;">2.下一题道具：{{data11.next_prop}}</p>

							<p class="notePart2"><img class="cepingi" src="/static/qmsj/img/cepingbox2.jpg" alt="">注意事项</p>
							<div class="cepcontBox">
								<img class="cepingimg" :src="data11.notes_img" v-if="data11.notes_img" alt="">
								<p style="padding-left:12px ">{{data11.notes}}</p>
							</div>

							<p class="notePart2"><img class="cepingi" src="/static/qmsj/img/cepingbox3.jpg" alt="">题目说明</p>
							<div class="cepcontBox">
								<img class="cepingimg" :src="data11.explain_img" v-if="data11.explain_img" alt="">
								<p style="padding-left:12px ">{{data11.explain}}</p>
							</div>

						</div>
					</div>


				</el-col>
			</el-row>


			<div style="background: #fff;margin-top: 28px;padding-bottom:10px;display: flex;display: -webkit-flex;justify-content:center;align-items:center">
				<el-pagination background @current-change="tan" :page-size="pageone" :current-page="page" layout="prev, pager, next"
				 :total="biaonum">
				</el-pagination>
			</div>
		</div>

		<el-dialog title="测评开始" class="dialog" top="25vh" :visible.sync="dialogVisible" width="30%">
			<p style="text-indent: 28px;line-height: 22px;">您好！现在给您做的测评是儿研所最新的一个版本，其中会有多动症和自闭症的筛查，在测评过程中请您不要和宝宝进行交流，让宝宝独立完成，问您的问题请您如实回答以免影响测评结果，请您把手机调制静音，好测评开始。</p>
			<span slot="footer" class="dialog-footer">
				<el-button type="warning" size="mini" @click="dialogVisible = false">确 定</el-button>
			</span>
		</el-dialog>

		<el-dialog :close-on-click-modal="false" class="tanchuang" title="请确认以下项目" :visible.sync="datiwanc" width="35%" center>
			<div>为宝宝推荐课程:</div>
			<div class="box">
				<el-checkbox-group v-model="checkList">
					<el-checkbox v-for="(item,itindex2) in course_list" :key="itindex2" :label="item.name">{{item.name}}</el-checkbox>
				</el-checkbox-group>
			</div>
			<div>一、通过测评过程中的观察以及和家长的沟通，宝宝是否有以下现象？<p style="color:red;">（自闭症筛查项目，请谨慎勾选）</p>
			</div>
			<div style="margin-top: 5px;">
				<el-checkbox v-model="is_zibi">{{map.zibi}}</el-checkbox>
			</div>
			<div style="margin-top: 8px;"><span style="float: left;color: red;font-size: 20px;margin-right: 5px;">*</span>二、（专注力）整个测评中孩子在完成每一项工作时，是否能集中精力3-5分钟</div>
			<el-radio v-model="radio_a" label="1">是</el-radio>
			<el-radio v-model="radio_a" label="2">否</el-radio>
			<div style="margin-top: 8px;"><span style="float: left;color: red;font-size: 20px;margin-right: 5px;">*</span>三、（适应能力）进入教室后能很快和测评师进行互动</div>
			<el-radio v-model="radio_b" label="1">是</el-radio>
			<el-radio v-model="radio_b" label="2">否</el-radio>
			<span slot="footer" class="dialog-footer">
				<!--<el-button size="small" @click="tuijian(2)">取 消</el-button>-->
				<el-button size="small" type="warning" @click="tuijian(1)">确 定</el-button>
			</span>
		</el-dialog>

		<el-dialog title="测评结束" :visible.sync="end_dialogVisible" top="25vh" :close-on-click-modal="false"
		 :close-on-press-escape="false" :show-close="false" class="dialog" width="25%">
			<div style="text-indent: 30px;">好，本次测评结束，现在和您说一下测评结果，首先跟您说一下，测评并不是智力的测试，测出哪项偏弱您不必过分紧张，但必须重视。</div>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="close_dialog">取 消</el-button>
				<el-button size="small" type="warning" @click="close_dialog">确 定</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				checkList: [],
				is_zibi: false,
				datiwanc: false,
				theloading:'',
				biaonum: 1,
				pageone: 1,
				radio2: '',
				radio_a:'',
				radio_b:'',
				list_id: '',
				num: '',
				type: '',
				data11: "",
				map: "",
				page: 1,
				token: '',
				dialogVisible: true,
				end_dialogVisible: false,
				course_list:[
					{name:'抚触课'},
					{name:'运动课'},
					{name:'音乐课'},
					{name:'体操课'},
					{name:'生活课'},
					{name:'创意课'},
					{name:'科学课'},
					{name:'绘本课'},
					{name:'感统课'},
					{name:'数学课'},
					{name:'语言课'},
					{name:'感官课'},
				]
			}
		},
		filters: {
			shuju: function(val) {
				switch (val) {
					case 0:
						return 'A';
						break;
					case 1:
						return 'B';
						break;
					case 2:
						return 'C';
						break;
					case 3:
						return 'D';
						break;
					case 4:
						return 'E';
						break;
					case 5:
						return 'F';
						break;
				}
			}
		},
		methods: {
			close_dialog() {
				this.end_dialogVisible = false
				this.datiwanc = true
			},
			tuijian: function(type) {
				let self = this;

				if(!self.radio_a){
					self.$message.error('清完善专注力选项')
					return false;
				}
				if(!self.radio_b){
					self.$message.error('清完善适应能力选项')
					return false;
				}
                self.datiwanc = false;
				// self.$message({
				// 	message: '答题完成，正在生成报告,请稍后~',
				// 	type: 'success',
				// 	duration: 8000
				// });
                self.theloading = self.$loading({
                    lock: true,
                    text: '答题完成，正在生成报告,请稍后',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
				var zibi = 1; //1.未选择   2.已选择
				if (self.is_zibi) {
					zibi = 2;
				}
				$.ajax({
					url: process.env.apiUrl + `saas/ceping/cp_question_answer`,
					type: "post",
					dataType: "json",
					data: {
						list_id: self.list_id,
						num: self.num,
						answer_id: self.radio2,
						question_id: self.data11.id,
						tag: 2,
						zibi: zibi,
						months: self.months,
						classname: self.checkList,
						radio_a: self.radio_a,
						radio_b: self.radio_b,
						token: self.token
					},
					success: function(data) {
						if (data.status == 1) {
							self.$message({
								message: '生成报告完毕，正在跳转报告页面~',
								type: 'success',
								duration: 1000
							});
							setTimeout(function() {
                                self.theloading.close()
								self.$router.push({
									'name': 'historylc',
									query: {
										listid: self.list_id
									}
								})
							}, 1500)
						}else{
                            self.theloading.close()
							self.$message.error(data.msg)
						}
					},
					error:function () {
                        self.theloading.close()
                    }
				});
			},
			tijiao: function() {
				let self = this;
				if (self.num < self.map.count) {
                    self.theloading = self.$loading({
                        lock: true,
                        text: 'loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
					$.ajax({
						url: process.env.apiUrl + `saas/ceping/cp_question_answer`,
						type: "post",
						dataType: "json",
						data: {
							list_id: self.list_id,
							num: self.num,
							answer_id: self.radio2,
							question_id: self.data11.id,
							tag: 1,
							token: self.token
						},
						success: function(data) {
							if (data.status == 1) {
								self.$message({
									message: data.msg,
									type: 'success',
									duration: 1000
								});
								setTimeout(function() {
									self.num = self.page + 1;
									//                                    self.num++;
									$.ajax({
										url: process.env.apiUrl + `saas/ceping/cp_question_index`,
										type: "post",
										dataType: "json",
										data: {
											list_id: self.list_id,
											num: self.num,
											type: self.type,
											token: self.token
										},
										success: function(data) {
                                            self.theloading.close()
											self.page = self.num;
											self.radio2 = '';
											console.log(data);
											self.data11 = data.data;
											self.map = data.map;
											self.biaonum = Number(data.map.use_num);
											if (data.data.answer_id) {
												self.radio2 = Number(data.data.answer_id)
											}

										},
										error:function () {
                                            self.theloading.close()
                                        }
									});
								}, 1000)

							} else {
                                self.theloading.close()
								self.$message({
									message: data.msg,
									type: 'error',
									duration: 1000
								});
							}

						},
						error: function() {
                            self.theloading.close()
							self.$message({
								message: '提交答案失败',
								type: 'error',
								duration: 3000
							});
						}

					});
				} else {
					self.end_dialogVisible = true
				}
			},

			tan: function(e) {
				//                alert(1)
				console.log(e);
				let self = this;
				self.num = Number(e);
				self.page = Number(e);
				self.radio2 = '';
				$.ajax({
					url: process.env.apiUrl + `saas/ceping/cp_question_index`,
					type: "post",
					dataType: "json",
					data: {
						list_id: self.list_id,
						num: self.num,
						type: self.type,
						token: self.token
					},
					success: function(data) {
						console.log(data);
						self.data11 = data.data;
						self.map = data.map;
						self.biaonum = Number(data.map.use_num);
						if (data.data.answer_id) {
							self.radio2 = Number(data.data.answer_id)
						}
					}
				});

			},
		},
		mounted: function() {
			this.list_id = this.$route.query.iid;
			this.num = this.$route.query.num;
			this.type = this.$route.query.type;
			this.token = $.cookie('token');
			let self = this;
			$.ajax({
				url: process.env.apiUrl + `saas/ceping/cp_question_index`,
				type: "post",
				dataType: "json",
				data: {
					list_id: self.list_id,
					num: self.num,
					type: self.type,
					token: self.token
				},
				success: function(data) {
					console.log(data);
					self.data11 = data.data;
					self.map = data.map;
					self.biaonum = Number(data.map.use_num);
					if (data.data.answer_id) {
						self.radio2 = Number(data.data.answer_id)
					}


				}
			});

		}
	}
</script>

<style scoped>
	[v-cloak] {
		display: none;
	}

	body {
		color: #666;
		font-size: 16px;
	}

	p,
	label {
		margin: 0;
		padding: 0;
	}

	.box{
		margin-bottom: 10px;
	}
	.box .el-checkbox{
		margin-left: 28px !important;
	}

	#datiye .content {
		background: #fff;
		padding: 20px;

	}

	#datiye .title1 {
		/*font-size: 18px;*/
		color: #333;
		padding-bottom: 36px;

		box-sizing: border-box;
		padding-right: 15px;
	}

	.title1f {
		font-size: 20px;
		color: #666;
	}

	.selectlist {
		padding-bottom: 18px;
	}

	#datiye .selectlist .el-radio__input.is-checked+.el-radio__label {
		color: #E6BE8A;
	}

	#datiye .selectlist .el-radio__input.is-checked .el-radio__inner {
		border-color: #E6BE8A;
		background: #E6BE8A;
	}

	#datiye .selectlist .el-radio__label {
		font-size: 16px;
		padding-left: 10px;
	}

	#datiye .contentTitle {
		font-size: 22px;
		color: #333;
		padding-bottom: 20px;
	}

	#datiye .notePart {
		line-height: 34px;
		padding-left: 24px;
		padding-right: 12px;
	}

	.notePart2 {
		line-height: 34px;
		padding-left: 12px;
		padding-right: 12px;
	}

	.tijiaoBtn {
		line-height: 42px;
		height: 42px;
		padding-left: 42px;
		padding-right: 42px;
		border-radius: 22px;
		background: #E6BE8A;
		color: #fff;
		text-align: center;
		margin: 30px auto 0;
		cursor: pointer;
		width: 116px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
	}

	.cepingBox {
		padding: 20px;
		border-radius: 10px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
		height: 425px;
		overflow-y: scroll;
	}

	@media (min-width: 1500px) {
		.cepingBox {
			padding: 20px;
			border-radius: 10px;
			box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
			height: 550px;
			overflow-y: scroll;
		}

	}

	@media (min-width: 1900px) {
		.cepingBox {
			padding: 20px;
			border-radius: 10px;
			box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
			height: 700px;
			overflow-y: scroll;
		}

	}



	.cepingi {
		width: 20px;
		margin-right: 8px;
	}

	.cepcontBox {
		padding-left: 50px;
		padding-bottom: 15px;
	}

	.cepingimg {
		margin: 10px;
		border-radius: 10px;
		width: 150px;
	}

	#datiye .el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #E6BE8A;
		color: #fff;
	}

	#datiye .el-radio {
		white-space: normal;
		padding-right: 15px;
		box-sizing: border-box;
	}

	#datiye .el-radio .el-radio__label {
		line-height: 1.3;
	}

	.dialog .el-dialog__header {
		background-color: #E6BE8A;
		padding: 12px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/ceping/datiyelc.vue